import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { candidateEndpoints } from '@/modules/candidates/constants';
import { candidateJobNoteQueryKeys } from '@/modules/candidates/queries/queryKeys';
import { invalidateQuery } from '@/utils/queries';

type DeleteCandidateJobNoteParams = {
  candidateJobId: string;
  noteId: string;
};

export const useDeleteCandidateJobNoteMutation = () => {
  return useMutation({
    mutationFn: async ({
      candidateJobId,
      noteId,
    }: DeleteCandidateJobNoteParams) => {
      await fetchClient.DELETE(candidateEndpoints.candidateJobNote, {
        params: { path: { candidateJobId, noteId } },
      });
    },
    onSettled: (_data, _error, { candidateJobId }) => {
      invalidateQuery(candidateJobNoteQueryKeys.list(candidateJobId))();
    },
  });
};
